// Import jQuery => utilise celui de wp de base, evite duplicat de jquery
import jQuery from "jquery";
// export for others scripts to use
window.$ = window.jQuery = jQuery;

// https://splidejs.com/
import Splide from '@splidejs/splide';

$(function(){
	$('body').on('tablist_click', function(e, target){
		if(target == "#summary"){
			$('.js-configurator').addClass('--summary');
		}else{
			$('.js-configurator').removeClass('--summary');
		}
	});

	$(".js-configurator-splide-choices").each(function(){
		let $this_splideChoices = $(this);
		let splideChoices = new Splide( $this_splideChoices[0], {
			type   : 'slide',
			pagination: false,
			focus  : 'center',
			drag   : true,
			autoWidth: true,
			perPage: null,
			perMove: null,
			arrows: false,
			mediaQuery: 'min',
			breakpoints: {
				1141: {
					destroy: true,
					focus  : 0,
				},
			}
		});
		$this_splideChoices.data('splide', splideChoices);
		splideChoices.mount();
		$this_splideChoices.on('refresh', function(){
			// reinit slider
				// splideChoices.destroy();
				// splideChoices.mount();
				splideChoices.refresh();
				splideChoices.go(0);
		});
		$this_splideChoices.on('centerCurrent', function(){
			if($this_splideChoices.is(":visible")){
				splideChoices.refresh();
				let currentIndex = $this_splideChoices.find('.js-configurator-splide-radio:checked').closest(".splide__slide").index();
				splideChoices.go(currentIndex);
			}
		});

		setTimeout(()=> {
			$this_splideChoices.trigger('centerCurrent');
		}, 1000);

		$this_splideChoices.find('.js-configurator-splide-radio').on('change', function(){
			if (window.matchMedia("(max-width: 1140px)").matches) {
				$this_splideChoices.trigger('centerCurrent');
			}
		});
	});

	function checkShowHideArrows($splide){
		if($splide.is(":visible")){
			var $splide__list__item = $splide.find(".splide__list li");
			var $splide__track = $splide.find(".splide__track");
			var listWidth = 0;
			for (var i = 0; i < $splide__list__item.length; i++) {
				listWidth += $splide__list__item.eq(i).width();
			}
			if(listWidth > $splide__track.width()){
				$splide.removeClass("--hideArrows");
			}else{
				$splide.addClass("--hideArrows");
			}
		}
	}
	$(".js-configurator-splide-filters").each(function(){
		let $this_splideFilter = $(this);
		let splideFilter = new Splide( $this_splideFilter[0], {
			type   : 'slide',
			pagination: false,
			focus  : 'center',
			drag   : true,
			autoWidth: true,
			perPage: null,
			perMove: 2,
			mediaQuery: 'min',
			breakpoints: {
				1141: {
					focus  : 0,
					arrows: true
				}
			},
		  	classes: {
				arrows: 'splide__arrows',
				arrow : 'splide__arrow ',
				prev  : 'splide__arrow--prev',
				next  : 'splide__arrow--next',
			},
		});
		$this_splideFilter.data('splide', splideFilter);
		splideFilter.mount();
		let currentIndex = $this_splideFilter.find('.js-configurator-splide-filters-radio:checked').closest(".splide__slide").index();
		
		$this_splideFilter.on('checkShowHideArrows', function(){
			checkShowHideArrows($this_splideFilter);
		});
		$this_splideFilter.on('centerCurrent', function(){
			if($this_splideFilter.is(":visible")){
				let currentIndex = $this_splideFilter.find('.js-configurator-splide-filters-radio:checked').closest(".splide__slide").index();
				splideFilter.go(currentIndex);
			}
		});

		setTimeout(()=> {
			$this_splideFilter.trigger('checkShowHideArrows');
			$this_splideFilter.trigger('centerCurrent');
		}, 1000);

		$this_splideFilter.find('.js-configurator-splide-filters-radio').on('change', function(){
			$this_splideFilter.trigger('centerCurrent');
		});
	});

	$(".js-configurator-splide-layers").each(function(){
		let $this_splideLayers = $(this);
		let $splideLayer = new Splide( $this_splideLayers[0], {
			type   : 'slide',
			pagination: false,
			focus  : 'center',
			drag   : true,
			perPage: 1,
			arrows: true,
		  	classes: {
				arrows: 'splide__arrows',
				arrow : 'splide__arrow ',
				prev  : 'splide__arrow--prev',
				next  : 'splide__arrow--next',
			},
		});
		$this_splideLayers.data('splide', $splideLayer);
		$splideLayer.mount();
		$splideLayer.on( 'moved', (newIndex, prevIndex, destIndex) => {
			$(".js-configuratorLayer").addClass('js-mobileHide')
			$(".js-configuratorLayer").eq(newIndex).removeClass('js-mobileHide');
			$(".js-configuratorLayer").eq(newIndex).find(".js-configurator-splide-choices").each(function(){
				let $this_splideChoices = $(this);
				$this_splideChoices.trigger('refresh');
				setTimeout(()=>{
					$this_splideChoices.trigger('centerCurrent');
				},500);
			});
		} );
	});

	// radio show elem
		$(".js-configurator-radio-trigger-filter").on("change", function(){
			let $thisRadio = $(this);
			let $targets = $($thisRadio.attr("data-targets"));
			let filterValue = $thisRadio.val();
			let $target = $targets.filter("[data-show-on-radio~='"+filterValue+"']");
			$targets.addClass("js-configurator-filterOutSlide");
			for (var i = 0; i < $targets.length; i++) {
				$targets.eq(i).find('input').prop("required", false)
				if($thisRadio.prop('checked')){
					if($thisRadio.val() == "All" || $thisRadio.val() == "Tout"){
						$targets.eq(i).removeClass('js-configurator-filterOutSlide')
					}else{
						if($targets.eq(i).attr('data-show-on-radio').indexOf(filterValue) != -1){
							$targets.eq(i).removeClass('js-configurator-filterOutSlide')
						}
					}
				}
			}

			var $splide = $targets.closest(".splide");
			// reorder initial order slides
				var $splide__list = $splide.find('.splide__list');
				var $reordered = $splide.find('.splide__slide').sort(function (a, b) {
    				return parseInt(a.getAttribute('data-order')) - parseInt(b.getAttribute('data-order'));
				});
				// $reordered.remove()
				$reordered.appendTo($splide__list);
			// push filteredOutSlide to the end
				var $tomove = $splide.find('.splide__slide.js-configurator-filterOutSlide')
				$tomove.appendTo($splide__list);

			// force re render slider after filtering
				if($splide.length > 0){
					setTimeout(()=>{
						$splide.trigger('refresh');
					},50);
				}
		});
		$(".js-configurator-radio-trigger-filter:checked").trigger('change');

	// regler ici les soucis d'initialisation des sliders parce qu'initialisé en display none
		$(".js-tabListSplide__link").on("click", function(){
			var $target = $($(this).attr('href'));
			$target.find(".js-configurator-splide-filters").each(function(){
				let $this_splideFilter = $(this);
				$this_splideFilter.trigger('checkShowHideArrows');
				$this_splideFilter.trigger('centerCurrent');
			});
			setTimeout(()=>{
				$target.find(".js-configurator-splide-choices").each(function(){
					let $this_splideChoices = $(this);
					$this_splideChoices.trigger('centerCurrent');
				});
			},250);
		});
		$(".js-toggleSlide").on("click", function(){
			var $target = $($(this).attr('data-target'));
			setTimeout(()=>{
				$target.find(".js-configurator-splide-filters").each(function(){
					let $this_splideFilter = $(this);
					$this_splideFilter.trigger('checkShowHideArrows');
					$this_splideFilter.trigger('centerCurrent');
				});
				// $target.find(".js-configurator-splide-choices").each(function(){
				// 	let $this_splideChoices = $(this);
				// 	$this_splideChoices.trigger('centerCurrent');
				// });
			},500);
		});
});